import { Box, BoxProps } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { FC, useState } from 'react'
import { SectionList } from '../../comps/Filters'
import { Filters } from '../../comps/FiltersWeb'
import { useKeyboard } from '../../comps/KeyboardAwareModal/keyboardHook'
import { filterData, filterHeader, vaultTxnsFilterData } from '../../data/static/data'
import { filtersStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { TransactionsType } from '../../screens/TransactionNew/types'
import { isMobile } from '../../util/util'

interface FilterProps {
  hide?: boolean
  setFilterVisible: (data: boolean) => void
  filterVisible: boolean
  applyFilters: () => void
  path?: string
  clearFilters?: any
  updateSelectedDateInfo?: any
  filtersList?: any
  index?: any
}

const FiltersView: FC<FilterProps> = ({
  hide = false,
  setFilterVisible,
  filterVisible,
  applyFilters,
  path,
  clearFilters,
  updateSelectedDateInfo,
  filtersList,
  index,
}: FilterProps) => {
  const {
    checkSelected,
    checkReceivedSelected,
    checkRefundSelected,
    updateMin,
    updateReceivedMin,
    updateRefundMin,
    updateMax,
    updateReceivedMax,
    updateRefundMax,
    selectedFilteredData,
    selectedReceivedFilteredData,
    selectedRefundFilteredData,
    updateFilters,
    updateReceivedFilters,
    updateRefundFilters,
    updateFilterSettings,
    updateOtherFilters,
    clearSubscriptionFilters,
    updateApplyFilters,
    subMids,
    isSmid,
    selectedDateInfo,
    updateReceivedFilterSettings,
    updateRefundFilterSettings,
  } = useStores((store) => ({
    checkSelected: store.transactions.filter.checkSelected,
    checkReceivedSelected: store.transactions.receivedFilter.checkSelected,
    checkRefundSelected: store.transactions.refundFilter.checkSelected,
    updateFieldSettings: store.transactions.updateFieldSettings,
    updateMin: store.transactions.filter.updateMin,
    updateReceivedMin: store.transactions.receivedFilter.updateMin,
    updateRefundMin: store.transactions.refundFilter.updateMin,
    updateMax: store.transactions.filter.updateMax,
    updateReceivedMax: store.transactions.receivedFilter.updateMax,
    updateRefundMax: store.transactions.refundFilter.updateMax,
    selectedFilteredData: store.transactions.filter.getFilterData,
    selectedReceivedFilteredData: store.transactions.receivedFilter.getFilterData,
    selectedRefundFilteredData: store.transactions.refundFilter.getFilterData,
    updateFilters: store.transactions.filter.updateFilters,
    updateReceivedFilters: store.transactions.receivedFilter.updateFilters,
    updateRefundFilters: store.transactions.refundFilter.updateFilters,
    updateFilterSettings: store.transactions.filter.updateAllFilters,
    updateReceivedFilterSettings: store.transactions.receivedFilter.updateAllFilters,
    updateRefundFilterSettings: store.transactions.refundFilter.updateAllFilters,
    getALLFields: store.transactions.getALLFields,
    updateOtherFilters: store.transactions.filter.updateOtherFilters,
    updateOtherReceivedFilters: store.transactions.receivedFilter.updateOtherFilters,
    updateOtherRefundFilters: store.transactions.refundFilter.updateOtherFilters,
    clearSubscriptionFilters: store.transactions.filter.clearSubscriptionFilters,
    clearReceivedSubscriptionFilters: store.transactions.receivedFilter.clearSubscriptionFilters,
    clearRefundSubscriptionFilters: store.transactions.refundFilter.clearSubscriptionFilters,
    updateApplyFilters: store.transactions.filter.applyFilters,
    updateReceivedApplyFilters: store.transactions.receivedFilter.applyFilters,
    updateRefundApplyFilters: store.transactions.refundFilter.applyFilters,
    subMids: store.user.getSubMerchants(),
    isSmid: store.user.isSmid,
    selectedDateInfo: store.transactions.selectedDateInfo,
  }))

  const isLargeScreen = useIsLargeScreen()
  const [keyboardHeight] = useKeyboard()
  const [statusBarHeight, setStatusbarHeight] = useState(0)

  if (hide) {
    return null
  }

  const FilterData = (): void => {
    setFilterVisible(!filterVisible)
  }

  const handleApply = (): void => {
    setFilterVisible(!filterVisible)
    if (path === TransactionsType.subscriptions) {
      updateApplyFilters(true)
    }
    applyFilters()
  }

  const hanldleDateChange = (dateObj) => {
    //updateDate(dateObj) don't update transaction date object
    updateSelectedDateInfo(dateObj)
  }

  const isSmallDevice = isMobile(isLargeScreen)

  const filterList = path === Routes.VAULT_TOKENIZATION ? vaultTxnsFilterData : filterData
  if (isSmallDevice) {
    return (
      <Box {...styles.boxWrapper(keyboardHeight, statusBarHeight)}>
        <SectionList
          onPress={FilterData}
          apply={handleApply}
          updateMin={index === 0 ? updateReceivedMin : updateRefundMin}
          updateMax={index === 0 ? updateReceivedMax : updateRefundMax}
          selectedFilteredData={index === 0 ? selectedReceivedFilteredData : selectedRefundFilteredData}
          updateFilters={index === 0 ? updateReceivedFilters : updateRefundFilters}
          updateFilterSettings={index === 0 ? updateReceivedFilterSettings : updateRefundFilterSettings}
          filterData={filterList}
          filterHeader={filterHeader}
          checkSelected={index === 0 ? checkReceivedSelected : checkRefundSelected}
          filtersStrings={filtersStrings}
          updateDate={hanldleDateChange}
          selectedDateInfo={selectedDateInfo}
          clearFilters={clearFilters}
        />
      </Box>
    )
  }

  return (
    <Filters
      path={path}
      onPress={FilterData}
      apply={handleApply}
      updateMin={updateMin}
      updateMax={updateMax}
      selectedFilteredData={selectedFilteredData}
      updateFilters={updateFilters}
      updateFilterSettings={updateFilterSettings}
      filterData={filterList}
      filterHeader={filterHeader}
      checkSelected={checkSelected}
      filtersStrings={filtersStrings}
      updateOtherFilters={updateOtherFilters}
      clearSubscriptionFilters={clearSubscriptionFilters}
      subMids={subMids}
      showMidFilter={isSmid}
    />
  )
}

const styles = {
  boxWrapper: (keyboardHeight: number, statusBarHeight: number) =>
    ({
      marginBottom: statusBarHeight > 30 ? keyboardHeight - statusBarHeight : 0,
    } as BoxProps),
}

export default FiltersView
